
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class SysParaDialog extends Serenity.EntityDialog<SysParaRow, any> {
        protected getFormKey() { return SysParaForm.formKey; }
        protected getIdProperty() { return SysParaRow.idProperty; }
        protected getLocalTextPrefix() { return SysParaRow.localTextPrefix; }
        protected getNameProperty() { return SysParaRow.nameProperty; }
        protected getService() { return SysParaService.baseUrl; }
        protected getDeletePermission() { return SysParaRow.deletePermission; }
        protected getInsertPermission() { return SysParaRow.insertPermission; }
        protected getUpdatePermission() { return SysParaRow.updatePermission; }

        protected form = new SysParaForm(this.idPrefix);

    }
}